export default {"src":"/_next/static/media/cronos.b06f8311.svg","height":48,"width":48,"blurWidth":0,"blurHeight":0};